import { createSlice } from "@reduxjs/toolkit";
import { FoundationsState } from "./types";
import { fetchFoundations } from "./foundations-thunk";
import { ErrorType } from "@/shared/types";

const initialState: FoundationsState = {
    foundations: [],
    isFoundationsLoading: false,
    foundationsError: null,
    isFoundationsFirstLoad: true
}

const foundationsSlice = createSlice({
    name: 'foundations',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
        .addCase(fetchFoundations.pending, (state) => {
            state.foundationsError = null
            state.isFoundationsLoading = true
        })
        .addCase(fetchFoundations.fulfilled, (state, action) => {
            state.foundationsError = null
            state.isFoundationsLoading = false
            state.isFoundationsFirstLoad = false
            state.foundations = action.payload
        })
        .addCase(fetchFoundations.rejected, (state, action) => {
            state.foundationsError = action.payload as ErrorType ?? null
            state.isFoundationsLoading = false
        })
    },
})

export default foundationsSlice.reducer